import React, { useState, useEffect } from "react";
import "@aws-amplify/ui-react/styles.css";
import "./Test.css";

import { openTime } from "./TimeTable";
import { View } from "@aws-amplify/ui-react";

let debug = true;
var currentUrl = window.location.href;
if (currentUrl.includes("master")) {
  debug = false;
}
console.log("currentUrl", currentUrl);
console.log("debug", debug);

const daysOfWeek = ["週日", "週一", "週二", "週三", "週四", "週五", "週六"];
const time = { 早診: "09:00-11:50", 午診: "15:00-17:50", 晚診: "18:00-22:50" };
function getUTC8Time() {
  // 獲取當前時間
  const now = new Date();

  // 獲取當前時間的 UTC 時間
  const utcTime = now.getTime() + now.getTimezoneOffset() * 60000;

  // 計算 UTC+8 的時間
  const utc8Time = new Date(utcTime + 8 * 60 * 60000);

  return utc8Time;
}

const today = getUTC8Time();
const currentTotalMinutes = today.getHours() * 60 + today.getMinutes();
const currentDayOfWeek = today.getDay(); // 0 (Sun) to 6 (Sat)
const day = daysOfWeek[currentDayOfWeek];
let openHour = {};
const Onsite = () => {
  const [selectedFirstFollow, setSelectedFirstFollow] = useState("first");

  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    if (openTime.hansheng[day].length !== 0) {
      openHour.clinic = "hansheng";
      openHour.time = openTime.hansheng[day];
    } else if (openTime.yoyo[day].length !== 0) {
      openHour.clinic = "yoyo";
      openHour.time = openTime.yoyo[day];
    }
    if (Object.keys(openHour).length !== 0) {
      // check if the currentMinute is within the time range
      Object.entries(time).forEach(([key, value]) => {
        const [startTime, endTime] = value.split("-");
        const [startHours, startMinutes] = startTime.split(":").map(Number);
        const startTotalMinutes = startHours * 60 + startMinutes;
        const [endHours, endMinutes] = endTime.split(":").map(Number);
        const endTotalMinutes = endHours * 60 + endMinutes;

        if (
          currentTotalMinutes >= startTotalMinutes &&
          currentTotalMinutes <= endTotalMinutes
        ) {
          if (openHour.time.includes(key)) {
            openHour.hour = key;
            openHour.day = day;
            openHour.date = `${today.getFullYear()}-${String(
              today.getMonth() + 1
            ).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
            setIsOpen(true);
            console.log("clinic", openHour.clinic);
            console.log("hour", openHour.hour);
            console.log("day", openHour.day);
            return;
          }
        }
      });
    }
  }, []);

  return (
    <View
      style={{
        width: "90vw",
        margin: "0 auto",
        // display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div>
        {isOpen ? (
          <div>
            {" "}
            <p className="header">
              您預約的門診為兒童成長發育專科(自費)(
              {selectedFirstFollow === "first" ? "初診" : "複診"})
            </p>
            <p className="header">
              預約時間為 {openHour.date} {openHour.day} {openHour.hour} 現場號
              李如浩醫師
            </p>
          </div>
        ) : (
          <h2>診所休息中</h2>
        )}
      </div>
    </View>
  );
};

export default Onsite;
